import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { profile } from '../data/profile';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      await emailjs.send(
        serviceId,
        templateId,
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        publicKey
      );

      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section">
      <div className="container">
        <header className="section-head">
          <p className="eyebrow">Contact</p>
          <h2>Start a conversation.</h2>
          <p className="lede">
            For roles, collaborations, or a closer look at shipped work.
          </p>
        </header>
        <div className="contact-layout">
          <div className="contact-card">
            <h3>Direct</h3>
            <div className="contact-list">
              <div>
                <span>Phone</span>
                <a href={profile.phoneHref}>{profile.phone}</a>
              </div>
              {profile.emails.map((item) => (
                <div key={item.value}>
                  <span>{item.label} email</span>
                  <a href={`mailto:${item.value}`}>{item.value}</a>
                </div>
              ))}
              <div>
                <span>LinkedIn</span>
                <a href={profile.links.linkedin} target="_blank" rel="noopener noreferrer">
                  {profile.links.linkedinLabel}
                </a>
              </div>
              <div>
                <span>GitHub</span>
                <a href={profile.links.github} target="_blank" rel="noopener noreferrer">
                  {profile.links.githubLabel}
                </a>
              </div>
            </div>
          </div>
          <form className="form-card" onSubmit={handleSubmit}>
            <label htmlFor="name">
              Name
              <input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </label>
            <label htmlFor="email">
              Email
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </label>
            <label htmlFor="message">
              Message
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </label>
            <button className="btn" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Sending…' : 'Send message'}
            </button>
            {submitStatus === 'success' && (
              <p className="form-note success">Message sent. I will reply soon.</p>
            )}
            {submitStatus === 'error' && (
              <p className="form-note error">
                The form could not send. Email tasniaanower@iut-dhaka.edu instead.
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
